// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { ThemeManager } from '../../misc/ThemeManager';
export class QuickTreeNode {
    constructor(text) {
        this.visible = true;
        this.selected = false;
        this.nodeId = '';
        this.nodeLevel = 0;
        this.hasVisibleChild = false;
        this.childNodesMap = {};
        this.parentNode = null;
        this.collapsed = true;
        this.CollapseRectangle = new Rectangle();
        this.CheckBoxRectangle = new Rectangle();
        this.ImgRectangle = new Rectangle();
        this.TextRectangle = new Rectangle();
        this.DisplayRectangle = new Rectangle();
        this.collapsedImageDef = null;
        this.collapsedImageSelected = null;
        this.expandedImageDef = null;
        this.expandedImageSelected = null;
        this.tag = null;
        this.checked = false;
        this.textPattern = null;
        this.checkedChildsCount = 0;
        this._childNodes = [];
        this.nodeText = text;
    }
    get childNodes() {
        return this._childNodes;
    }
    set childNodes(value) {
        this._childNodes = value !== null && value !== void 0 ? value : [];
        this.childNodesMap = {};
        for (let i = 0; i < this._childNodes.length; i++) {
            const childNode = this._childNodes[i];
            this.childNodesMap[childNode.nodeText] = childNode;
        }
    }
    AddChildNode(newNode) {
        newNode.parentNode = this;
        this._childNodes.push(newNode);
        this.childNodesMap[newNode.nodeText] = newNode;
    }
    AddChildNodeRange(newNodesArray) {
        const len = newNodesArray.length;
        for (let i = 0; i < len; i++) {
            newNodesArray[i].parentNode = this;
            this.childNodesMap[newNodesArray[i].nodeText] = newNodesArray[i];
        }
        this._childNodes = this._childNodes.concat(newNodesArray);
    }
    RemoveChildNode(node) {
        const index = this._childNodes.indexOf(node);
        if (index === -1) {
            return;
        }
        this._childNodes.splice(index, 1);
        if (this.childNodesMap[node.nodeText] === node) {
            delete this.childNodesMap[node.nodeText];
        }
    }
    RemoveAllChildNodes() {
        this._childNodes = [];
        this.childNodesMap = {};
    }
    GetChildNodeByText(nodeText) {
        var _a;
        return (_a = this.childNodesMap[nodeText]) !== null && _a !== void 0 ? _a : null;
    }
    HasChildNodes() {
        return this.hasVisibleChild && this.childNodes.length > 0;
    }
    GetFirstChild() {
        return this.childNodes[0] || null;
    }
    GetLastChild() {
        return this.childNodes.length > 0 ? this.childNodes[this.childNodes.length - 1] : null;
    }
    getFullPath() {
        let path = this.nodeText;
        let parent = this.parentNode;
        while (parent !== null) {
            path += parent.nodeText;
            parent = parent.parentNode;
        }
        return path;
    }
    setCheck(value) {
        if (this.checked === value) {
            return;
        }
        const parent = this.parentNode;
        if (!isNullOrUndefined(parent)) {
            const previousCount = parent.checkedChildsCount;
            if (value) {
                parent.checkedChildsCount++;
            }
            else {
                parent.checkedChildsCount--;
            }
            if (parent.checkedChildsCount === parent.childNodes.length) {
                parent.setCheck(true);
            }
            else if (previousCount === parent.childNodes.length) {
                parent.setCheck(false);
            }
        }
        this.checked = value;
    }
    DoCollapse() {
        this.collapsed = !this.collapsed;
    }
    getForegroundColor(expanded, isHovered) {
        if (expanded) {
            if (this.selected) {
                return ThemeManager.colors.quickTreeNodeForegroundExpandedSelected;
            }
            else if (isHovered) {
                return ThemeManager.colors.quickTreeNodeForegroundExpandedHovered;
            }
            else {
                return ThemeManager.colors.quickTreeNodeForegroundExpanded;
            }
        }
        else {
            if (this.selected) {
                return ThemeManager.colors.quickTreeNodeForegroundSelected;
            }
            else if (isHovered) {
                return ThemeManager.colors.quickTreeNodeForegroundHovered;
            }
            else {
                return ThemeManager.colors.quickTreeNodeForeground;
            }
        }
    }
    getCollapsedImage() {
        return this.selected ? this.collapsedImageSelected : this.collapsedImageDef;
    }
    getExpandedImage() {
        return this.selected ? this.expandedImageSelected : this.expandedImageDef;
    }
    getTooltip(ctx) {
        return null;
    }
}
